import ahoy from "@lib/ahoy";
import { useRouter } from "@lib/i18n/navigation-pages-router";
import CanonicalUrl from "@components/layout/CanonicalUrl";
import Auth from "./Auth";

const PageAuth = ({ initType, afterSignInPath }) => {
  const FORBIDDEN_REDIRECTIONS = ["/sign-out"];
  const router = useRouter();

  function redirectUser(type, authBy, user) {
    if (afterSignInPath && !FORBIDDEN_REDIRECTIONS.includes(afterSignInPath)) {
      router.replace(afterSignInPath);
    } else if (user.state === "lead") {
      router.replace("/je-commence");
    } else {
      router.replace("/home");
    }

    if (type !== "signin") {
      ahoy("signupsuccess", { authBy });
    }
  }

  return (
    <>
      <CanonicalUrl />
      <Auth
        initType={initType}
        onAfterAuth={redirectUser}
      />
    </>
  );
};

export default PageAuth;
